module.exports = __webpack_public_path__ + "static/media/English_US_Kevin BG-43.cc1f57d9.png";